export default __webpack_public_path__ + "static/how-to-use-nomba-qr-c5cf7eb8ad22750fbfa7440b523b0aa4.webm";